import {
  DataPopper,
  DataPopperRow,
  RatioProgressBar,
  tokens,
  Typography,
  Box,
  Stack,
} from '@cast/design-system';
import { formatPercentage } from '@cast/utils';

import type { CostReportClusterSummaryNormalized } from '@cast/shared-cost-data-access';

import { DataTooltip } from '@cast/components-data-tooltip';

type SpotUsageCellProps = {
  summary: CostReportClusterSummaryNormalized;
};

export const SpotUsageCell = ({ summary }: SpotUsageCellProps) => {
  const nodeCountOnDemand = summary.nodeCountOnDemand.toNumber();
  const nodeCountSpot = summary.nodeCountSpot.toNumber();
  const nodeCountSpotFallbackCastai =
    summary.nodeCountSpotFallbackCastai.toNumber();
  const nodesCountTotal = summary.nodesCountTotal.toNumber();
  const spotPercent = nodesCountTotal
    ? (nodeCountSpot / nodesCountTotal) * 100
    : 0;

  return (
    <Stack gap={3} width="100%">
      <Typography
        data-testid="spot-usage-percent"
        variant="P12R"
        sx={{ color: tokens.theme.fg.structural.primary }}
      >
        {formatPercentage(spotPercent, { roundBy: 1 })}
      </Typography>
      <DataTooltip
        title={
          <DataPopper testId="spot-usage-tooltip">
            <DataPopperRow
              indicator={{ color: tokens.theme.data.indigo800 }}
              left="Spot"
              right={nodeCountSpot}
            />
            <DataPopperRow
              indicator={{ color: tokens.theme.data.yellow400 }}
              left="Fallback"
              right={nodeCountSpotFallbackCastai}
            />
            <DataPopperRow
              indicator={{ color: tokens.theme.data.blue300 }}
              left="On-demand"
              right={nodeCountOnDemand}
            />
          </DataPopper>
        }
      >
        <Box width="100%" data-testid="spot-usage-progress-bar">
          <RatioProgressBar
            hideBorders
            sx={{ cursor: 'pointer' }}
            bars={[
              {
                value: nodeCountSpot,
                color: tokens.theme.data.indigo800,
              },
              {
                value: nodeCountSpotFallbackCastai,
                color: tokens.theme.data.yellow400,
              },
              {
                value: nodeCountOnDemand,
                color: tokens.theme.data.blue300,
              },
            ]}
          />
        </Box>
      </DataTooltip>
    </Stack>
  );
};
